import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Configurations } from '../core/configurations';
import { AuthService } from './auth.service';
import { VersioneApplicativo } from '../models/shared/versioneApplicativo.model';
import { Observable } from 'rxjs';

@Injectable()
export class UltimaVersioneApplicativoClientService {
  APIDizionari = this.configuration.apiBaseUrlUltimaVersioneApplicativo;
  MetodoGetUltimaVersione = "GetUltimaVersioneApplicativoClient";

  constructor(private http: Http, private configuration: Configurations, private authenticationService:AuthService) {
    
  }

  getUltimaVersioneApplicativo(): Observable<VersioneApplicativo> {

    let url = this.APIDizionari + this.MetodoGetUltimaVersione;
    return this.http.get(url)
      .map((r: Response) => r.json() as VersioneApplicativo).catch((r:any)=> {
        if(r.status===401) {
          this.authenticationService.logoutIfSessionExpired().subscribe(
            (res:any)=> {
  
            });
          return Observable.throw("Autorizzazione negata.");
        }
        return Observable.throw(r);
      });
  }

}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/services/ultima-versione-applicativo-client.service.ts